// extracted by mini-css-extract-plugin
export default {"header":"FileUpload--header--cedc58","description":"FileUpload--description--2ff940","buttonWrapper":"FileUpload--buttonWrapper--37b541","fileName":"FileUpload--fileName--1d664c"};